import { NumberCons, StringConst } from '../../constants/const';

export class MissingProduct {
  id: number;
  type: string;
  itemCode: string;
  description: string;
  arrivalDate?: string | null;
  comments: string;
  action?: string;
  createDate?: string;
  available?: number | boolean;
  catalogGroup?: string;
  activePrinciple?: string;
  isAutomatic: number;
  constructor() {
    this.id = 0;
    this.type = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
    this.arrivalDate = StringConst.empty;
    this.comments = StringConst.empty;
    this.action = StringConst.empty;
    this.createDate = StringConst.empty;
    this.available = -1;
    this.catalogGroup = StringConst.empty;
    this.activePrinciple = StringConst.empty;
    this.isAutomatic = NumberCons.zero;
  }
}
export class ConfigMissingProduct{
  codigo: string;
  create: boolean;
  probableArrival: boolean;
  description: boolean;
  observations: boolean;
  material: boolean;
  active: boolean;
  constructor() {
    this.codigo = '';
    this.create = false;
    this.probableArrival = false;
    this.description = false;
    this.observations = false;
    this.material = false;
    this.active = false;
  }
}

export interface IGetMissingProductsResponse{
  code: number;
  comments: string;
  exceptionMessage: any;
  response: Array<MissingProduct>;
  success: boolean;
  userError: any;
}
